module.exports = __webpack_public_path__ + "a8a98a655f57dd28430f488fbeedeb81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/works-with/devices/apple-watch.png
// module id = 1785
// module chunks = 1